const env = process.env.NODE_ENV || "development";

const apiEnvironment = {
  development: {
        api: "https://vinhlong-api.cgis.asia/",
  },
  production: {
    api: "https://vinhlong-api.cgis.asia/",
  },
};

module.exports = apiEnvironment[env];
